// components/default/forms/DatePicker.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import { useState } from "react";
import {
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import DateTimePickerModal from "react-native-modal-datetime-picker";

interface DatePickerProps {
  value: string; // YYYY-MM-DD
  onChange: (date: string) => void;
  label?: string;
  placeholder?: string;
  containerStyle?: any;
}

export default function DatePicker({
  value,
  onChange,
  label,
  placeholder = "Select date",
  containerStyle,
}: DatePickerProps) {
  const { colors, spacing } = useAppTheme();
  const [isVisible, setIsVisible] = useState(false);

  const styles = StyleSheet.create({
    container: { marginBottom: 16 },
    label: {
      fontSize: 14,
      fontWeight: "500",
      color: colors.text,
      marginBottom: 4,
    },
    dateButton: {
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: 8,
      padding: 12,
      backgroundColor: colors.background,
    },
    dateText: { fontSize: 16, color: colors.text },
  });

  if (Platform.OS === "web") {
    return (
      <View style={[styles.container, containerStyle]}>
        {label && <Text style={styles.label}>{label}</Text>}
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={{
            width: "100%",
            padding: 12,
            borderWidth: 1,
            borderColor: colors.border,
            borderRadius: 8,
            backgroundColor: colors.background,
            color: colors.text,
            fontSize: 16,
            outline: "none",
          }}
        />
      </View>
    );
  }

  // Native
  return (
    <View style={[styles.container, containerStyle]}>
      {label && <Text style={styles.label}>{label}</Text>}
      <TouchableOpacity
        style={styles.dateButton}
        onPress={() => setIsVisible(true)}
      >
        <Text style={styles.dateText}>
          {value ? new Date(value).toLocaleDateString() : placeholder}
        </Text>
      </TouchableOpacity>
      <DateTimePickerModal
        isVisible={isVisible}
        mode="date"
        onConfirm={(date) => {
          onChange(date.toISOString().split("T")[0]);
          setIsVisible(false);
        }}
        onCancel={() => setIsVisible(false)}
      />
    </View>
  );
}
